import { USER_AGREEMENT_QUESTION } from './constants-app-texts';

export const CHATBOT_OPENING_QUESTION = `${USER_AGREEMENT_QUESTION} <br />
  Anschließend werde ich mit dem Chatbot verbunden. <br />`;
